import { render, staticRenderFns } from "./ExtActFlowDataModal.vue?vue&type=template&id=1ff1a542&scoped=true&"
import script from "./ExtActFlowDataModal.vue?vue&type=script&lang=js&"
export * from "./ExtActFlowDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff1a542",
  null
  
)

export default component.exports